import { ContractingConfigurationDTO } from "features/contracting/dtos/ContractingConfigurationDTO";
import { ContractingDTO } from "features/contracting/dtos/ContractingDTO";
import { ContractingFormType } from "features/contracting/enums/contractingFormType";
import ContractingStepData from "features/contracting/models/ContractingStepData";
import { FormFields } from "features/shared/forms/hooks/useForm";
import IKeyValuePair from "features/shared/models/IKeyValuePair";

export type TouchedActionData = {
  touched: boolean;
  stepRoute: string;
}

export enum ContractingActionTypes {
  SET_CONTRACTING_PROGRESS = "@@contracting/SET_CONTRACTING_PROGRESS",
  SET_ALL_CONTRACTING_STEPS = "@@contracting/SET_ALL_CONTRACTING_STEPS",
  SET_CONTRACTING_STEP = "@@contracting/SET_CONTRACTING_STEP",
  SET_CONTRACTING_STEP_TOUCHED = "@@contracting/SET_CONTRACTING_STEP_TOUCHED",
  SET_CONTRACTING_STEP_VALID = "@@contracting/SET_CONTRACTING_STEP_VALID",
  SET_CONTRACTING_STEP_DISABLED = "@@contracting/SET_CONTRACTING_STEP_DISABLED",
  SET_CONTRACTING_STEP_VALUES = "@@contracting/SET_CONTRACTING_STEP_VALUES",
  SET_CONTRACTING_ID = "@@contracting/SET_CONTRACTING_ID",
  SET_CONTRACTING_CONFIGURATION = "@@contracting/SET_CONTRACTING_CONFIGURATION",
}

export type ContractingAction = 
  | { type: ContractingActionTypes.SET_CONTRACTING_PROGRESS, data: ContractingDTO }
  | { type: ContractingActionTypes.SET_ALL_CONTRACTING_STEPS, data: Record<string, ContractingStepData> }
  | { type: ContractingActionTypes.SET_CONTRACTING_STEP, data: IKeyValuePair<ContractingFormType, ContractingStepData> }
  | { type: ContractingActionTypes.SET_CONTRACTING_STEP_TOUCHED, data: IKeyValuePair<ContractingFormType, TouchedActionData> }
  | { type: ContractingActionTypes.SET_CONTRACTING_STEP_VALID, data: IKeyValuePair<ContractingFormType, boolean> }
  | { type: ContractingActionTypes.SET_CONTRACTING_STEP_DISABLED, data: IKeyValuePair<ContractingFormType, boolean> }
  | { type: ContractingActionTypes.SET_CONTRACTING_STEP_VALUES, data: IKeyValuePair<ContractingFormType, FormFields> }
  | { type: ContractingActionTypes.SET_CONTRACTING_ID, data: string }
  | { type: ContractingActionTypes.SET_CONTRACTING_CONFIGURATION, data: ContractingConfigurationDTO }

export const setContractingProgress = (data: ContractingDTO): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_PROGRESS,
    data: data
  }
}

export const setAllContractingSteps = (data: Record<string, ContractingStepData>): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_ALL_CONTRACTING_STEPS,
    data: data
  }
}

export const setContractingStep = (data: IKeyValuePair<ContractingFormType, ContractingStepData>): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_STEP,
    data: data
  }
}

export const setContractingStepTouched = (data: IKeyValuePair<ContractingFormType, TouchedActionData>): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_STEP_TOUCHED,
    data: data
  }
}

export const setContractingStepValid = (data: IKeyValuePair<ContractingFormType, boolean>): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_STEP_VALID,
    data: data
  }
}

export const setContractingStepDisabled = (data: IKeyValuePair<ContractingFormType, boolean>): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_STEP_DISABLED,
    data: data
  }
}

export const setContractingStepValues = (data: IKeyValuePair<ContractingFormType, FormFields>): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_STEP_VALUES,
    data: data
  }
}

export const setContractingId = (data: string): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_ID,
    data: data
  }
}

export const setContractingConfig = (data: ContractingConfigurationDTO): ContractingAction => {
  return {
    type: ContractingActionTypes.SET_CONTRACTING_CONFIGURATION,
    data: data
  }
}